module.exports = __webpack_public_path__ + "media/images/athletes/2510-f13c658c58a3cb1ae4ba01e8603ad146.png";